// extracted by mini-css-extract-plugin
export default {"icon":"Fgy7f","unreadCircle":"fqsHZ"};